// extracted by mini-css-extract-plugin
export default {"middle":"styles_middle__qdETK","image":"styles_image__Yx0qW"};